import Splide from '@splidejs/splide';

class OtherMarathons {
  constructor(element) {
    this.blockElement = element;
    this.splideElement = this.blockElement.querySelector('.splide');
  }

  init() {
    if (!this.splideElement) {
      return;
    }

    const splide = new Splide(this.splideElement, {
      type: 'slide',
      perPage: 2,
      arrows: true,
      pagination: false,
      gap: '24px',

      autoWidth: true,
      trimSpace: false,
      breakpoints: {
        768: {
          perPage: 1,
          pagination: true,
          arrows: false,
          gap: '16px',
          focus: 'center',
        },
      },
    });

    splide.mount();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.other-marathons-block')
    .forEach((blockElement) => {
      const instance = new OtherMarathons(blockElement);
      instance.init();
    });
});

// Gutenberg / ACF – po załadowaniu lub dodaniu bloku
if (typeof acf !== 'undefined') {
  acf.addAction('ready', (el) => {
    document
      .querySelectorAll('.other-marathons-block')
      .forEach((blockElement) => {
        const instance = new OtherMarathons(blockElement);
        instance.init();
      });
  });

  acf.addAction('append', (el) => {
    document
      .querySelectorAll('.other-marathons-block')
      .forEach((blockElement) => {
        const instance = new OtherMarathons(blockElement);
        instance.init();
      });
  });
}
